import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useFestivalTheme } from "@/context/FestivalThemeContext";
import PromoCarousel from "@/components/PromoCarousel";
import { LimitedTimePill } from "@/components/Festive";

const MAX_CARDS = 6;

/* B5 — banner tag pills carry the actual offer name (unique per card),
   never a repeated string. "Stock Up Fest" lives only in the top bar + heading. */
const withPill = (c) => {
  if (c.kind === "category") return { ...c, pill: c.subline || "Category Offer", subline: "" };
  if (c.kind === "brand") return { ...c, pill: (c.subline || "").replace(/ Store$/, "") || "Brand Spotlight" };
  if (c.kind === "deal") return { ...c, pill: "Top Deal" };
  return { ...c, pill: "Fest Offer" };
};

/**
 * FestHeroCarousel — STOCK UP FEST hero while a festival theme is on.
 * Admin custom cards first, automatic catalog cards behind them, on
 * amber-orange gradient panels.
 */
export default function FestHeroCarousel() {
  const { content } = useFestivalTheme();
  const [auto, setAuto] = useState(null);

  useEffect(() => {
    api.get("/shop/fest-hero")
      .then(({ data }) => setAuto(data.cards || []))
      .catch(() => setAuto([]));
  }, []);

  if (auto === null) return null;
  const custom = (content.custom_cards || [])
    .filter((c) => c.headline && c.link)
    .map((c) => withPill({ kind: "custom", headline: c.headline, subline: c.subline, image: c.image, link: c.link }));
  const cards = [...custom, ...auto.map(withPill)].slice(0, MAX_CARDS);
  if (cards.length === 0) return null;

  return (
    <>
      <div className="flex justify-center pt-[92px]">
        <LimitedTimePill text="Limited Time Sale" />
      </div>
      <PromoCarousel cards={cards} pill="Stock Up Fest" panelBase="fest-hero-panel" testidPrefix="fest-hero" />
    </>
  );
}
